import React from "react";
import "./App.css";
import PageRoutes from "./Router";

const App = () => {
  return <PageRoutes />;
};

export default App;
